import React from "react";
import "./Games_Video.css";

function GamesVideo() {
  return (
    <div className="games-video" id="games-video">
      <h1>Video of some games</h1>
      <iframe
        width="100%"
        height="600"
        src="https://www.youtube.com/embed/Z9_nxHph5w4"
        title="Games Video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
}

export default GamesVideo;
